<template>
  <div>
    <div class="block lg:hidden">
      <button
        id="nav-toggle"
        class="flex items-center text-gray-600 hover:text-gray-800 appearance-none focus:outline-none"
        @click="isOpen = !isOpen"
      >
        <svg
          class="fill-current"
          width="30px"
          height="30px"
          viewBox="0 0 50 50"
        >
          <path
            d="M49,38.5 C49.5522847,38.5 50,38.9477153 50,39.5 L50,42.5 C50,43.0522847 49.5522847,43.5 49,43.5 L21,43.5 C20.4477153,43.5 20,43.0522847 20,42.5 L20,39.5 C20,38.9477153 20.4477153,38.5 21,38.5 L49,38.5 Z M49,22.25 C49.5522847,22.25 50,22.6977153 50,23.25 L50,26.25 C50,26.8022847 49.5522847,27.25 49,27.25 L1,27.25 C0.44771525,27.25 6.76353751e-17,26.8022847 0,26.25 L0,23.25 C-6.76353751e-17,22.6977153 0.44771525,22.25 1,22.25 L49,22.25 Z M49,6 C49.5522847,6 50,6.44771525 50,7 L50,10 C50,10.5522847 49.5522847,11 49,11 L7,11 C6.44771525,11 6,10.5522847 6,10 L6,7 C6,6.44771525 6.44771525,6 7,6 L49,6 Z"
            id="Burger-Menu"
          ></path>
        </svg>
      </button>
    </div>

    <div
      v-if="isOpen"
      class="mobile-nav__menu px-4 py-2 bg-white absolute left-0 top-menu shadow w-full"
    >
      <template v-if="isAuth">
        <a
          href="/admin"
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
        >
          Admin Panel
        </a>
        <hr class="bg-gray-900" />
        <a
          href="/admin/account"
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
        >
          Account
        </a>
        <a
          href="/admin/settings"
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
        >
          Settings
        </a>
        <hr class="bg-gray-900" />
        <a
          href="/logout"
          class="block text-blue-600 hover:text-white hover:bg-red-500 px-4 py-2"
        >
          Logout
        </a>
      </template>
      <template v-else>
        <a
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
          href="/pricing"
        >
          Pricing
        </a>
        <a
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
          href="/faq"
        >
          F.A.Q.
        </a>
        <a
          href="/login"
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
        >
          Login
        </a>
        <a
          href="/register"
          class="block hover:text-white hover:bg-blue-500 focus:bg-blue-700 px-4 py-2"
        >
          Register
        </a>
        <div class="flex px-4 py-2">
          <a href="?lang=en" class="inline-flex items-center"
            >EN <img src="img/en.svg" class="pl-1 h-4 mr-3"
          /></a>
          <a href="?lang=el" class="inline-flex items-center"
            >GR <img src="img/el.svg" class="pl-1 h-4"
          /></a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: Object,
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    isAuth() {
      return Object.keys(this.user).length > 0;
    },
  },
};
</script>

<style scoped>
.top-menu {
  top: 56px;
}
</style>
